<template>
  <div v-if="hasAccess">
    <page-content>
      <messaging-settings-panel :show-domain-settings="false" />
    </page-content>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageContent from '@/components/PageContent.vue'
import MessagingSettingsPanel from '@/components/chats/MessagingSettingsPanel.vue'

export default {
  name: 'app-dashboard-global-messaging-settings',
  components: {
    PageContent,
    MessagingSettingsPanel
  },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.some(role => ['admin', 'community-manager'].includes(role))
    }
  },
  created () {
    if (!this.hasAccess) {
      this.$router.replace('/app/dashboard')
    }
  }
}
</script>
